export const TABLET_WIDTH = 768;
export const MOBILE_WIDTH = 415;

export const ENV_DEVELOPMENT = 'development';
export const ENV_PRODUCTION = 'production';

export const LIVE_ACCOUNT_PORTAL_ID = process.env.REACT_APP_HUBSPOT_PORTAL_ID ?? '';
export const MIGRATION_TEST_ACCOUNT_PORTAL_ID = process.env.REACT_APP_HUBSPOT_DEV_PORTAL_ID ?? '';
export const LIVE_ACCOUNT_FORM_GUID = process.env.REACT_APP_HUBSPOT_FORM_GUID ?? '';
export const MIGRATION_TEST_ACCOUNT_FORM_GUID = process.env.REACT_APP_HUBSPOT_DEV_FORM_GUID ?? '';

export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST ?? '';
export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY ?? '';
